module.exports = __webpack_public_path__ + "img/绿建类.2d29e460.png";